export async function requestTagGenerate(data: {
  title?: string
  content?: string
  seo?: boolean
}): Promise<
  {
    weighted?: number | undefined
    name: string
    hot: number
  }[]
> {
  const url = data.seo ? '/keyword/extractionseo' : '/keyword/extraction'
  return ganYuHttp
    .post<any[]>(url, {
      title: data.title || '',
      content: data.content || ''
    })
    .then((res) => res.data)
    .catch(() => [])
}
